import { render, staticRenderFns } from "./ScalingDown.vue?vue&type=template&id=7b6764ab&scoped=true&"
import script from "./ScalingDown.vue?vue&type=script&lang=js&"
export * from "./ScalingDown.vue?vue&type=script&lang=js&"
import style0 from "./ScalingDown.vue?vue&type=style&index=0&id=7b6764ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6764ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6764ab')) {
      api.createRecord('7b6764ab', component.options)
    } else {
      api.reload('7b6764ab', component.options)
    }
    module.hot.accept("./ScalingDown.vue?vue&type=template&id=7b6764ab&scoped=true&", function () {
      api.rerender('7b6764ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/ScalingDown.vue"
export default component.exports